import React from "react";
import ReactDOM from "react-dom";

import SubscriptionsContainer from "./components/subscriptions/SubscriptionsContainer";
import "./styles.css";

import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import {AC_DEV_LEVEL, PAYMENT_TYPE, VDS_LEVEL, VRI_LEVEL} from "./constants";
import PaymentMethodsContainer from "./components/paymentMethods/PaymentMethodsContainer";

TimeAgo.addDefaultLocale(en);

// Handles trusted-types-for CSP configuration.
if (typeof trustedTypes !== "undefined") {
    if (trustedTypes.defaultPolicy) {
        trustedTypes.defaultPolicy.createScriptUrl = trustedTypeCustomCreateScriptURL;
    } else {
        trustedTypes.createPolicy('default', {
            createScriptURL: trustedTypeCustomCreateScriptURL
        });
    }
}

function trustedTypeCustomCreateScriptURL(input) {
    if (!input || !(new URL(input))) {
        console.error('Failed to load input for trustedTypes policy');
        return;
    }

    if (new URL(input).origin === 'https://js.stripe.com') {
        return input;
    }
    return undefined;
}

document.addEventListener("DOMContentLoaded", () => {
    const subscriptionsContainer = document.getElementById('subscriptions-container');
    if (subscriptionsContainer) {
        ReactDOM.render(<SubscriptionsContainer/>, subscriptionsContainer);
    }

    const paymentMethodsContainer = document.getElementById('payment-methods-container');
    if (paymentMethodsContainer) {
        ReactDOM.render(<PaymentMethodsContainer/>, paymentMethodsContainer);
    }
});